export const postRequest = (url: string, data: {}): Promise<any> => {
  const request = new XMLHttpRequest();
  request.open('POST', url, true);

  request.setRequestHeader('Content-type', 'application/json');
  request.send(JSON.stringify(data));

  return new Promise((resolve, reject) => {
    request.onload = () => resolve(request.response);
    request.onerror = reject;
  });
};

export const getRequest = <T = any>(url: string): Promise<T> => {
  const request = new XMLHttpRequest();
  request.open('GET', url, true);
  request.send();

  return new Promise((resolve, reject) => {
    request.onload = () => resolve(request.response);
    request.onerror = reject;
  });
};

